import React from 'react';
import { Route } from 'react-router-dom';
import { ProductsLoadingDialog } from './products-loading-dialog/ProductsLoadingDialog';
import { ProductDeleteDialog } from './product-delete-dialog/ProductDeleteDialog';
import { ProductsDeleteDialog } from './products-delete-dialog/ProductsDeleteDialog';
import { ProductsFetchDialog } from './products-fetch-dialog/ProductsFetchDialog';
import { ProductsUpdateStatusDialog } from './products-update-status-dialog/ProductsUpdateStatusDialog';
import { ProductsCard } from './ProductsCard';
import { ProductsUIProvider } from './ProductsUIContext';

export function ProductsPage({ history }) {
  const productsUIEvents = {
    newProductButtonClick: () => {
      history.push('/products/new');
    },
    openEditProductPage: (id) => {
      history.push(`/products/${id}/edit`);
    },
    openDeleteProductDialog: (id) => {
      history.push(`/products/${id}/delete`);
    },
    openDeleteProductsDialog: () => {
      history.push(`/products/deleteProducts`);
    },
    openFetchProductsDialog: () => {
      history.push(`/products/fetch`);
    },
    openUpdateProductsStatusDialog: () => {
      history.push('/products/updateStatus');
    },
  };

  return (
    <ProductsUIProvider productsUIEvents={productsUIEvents}>
      <ProductsLoadingDialog />
      <Route path="/products/deleteProducts">
        {({ history, match }) => (
          <ProductsDeleteDialog
            show={match != null}
            onHide={() => {
              history.push('/products');
            }}
          />
        )}
      </Route>
      <Route path="/products/:id/delete">
        {({ history, match }) => (
          <ProductDeleteDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push('/products');
            }}
          />
        )}
      </Route>
      <Route path="/products/fetch">
        {({ history, match }) => (
          <ProductsFetchDialog
            show={match != null}
            onHide={() => {
              history.push('/products');
            }}
          />
        )}
      </Route>
      <Route path="/products/updateStatus">
        {({ history, match }) => (
          <ProductsUpdateStatusDialog
            show={match != null}
            onHide={() => {
              history.push('/products');
            }}
          />
        )}
      </Route>
      <ProductsCard />
    </ProductsUIProvider>
  );
}
